export default "__VITE_ASSET__7EwSk_p7__"